import { useEffect, useRef } from 'react';

export const useIntersectionObserver = () => {
  const observerRef = useRef(new IntersectionObserver(() => null));

  const updateCallback = (newCallback: IntersectionObserverCallback, element: Element) => {
    observerRef.current.disconnect();
    observerRef.current = new IntersectionObserver(newCallback);
    observerRef.current.observe(element);
  };

  useEffect(() => {
    return () => observerRef.current.disconnect();
  }, []);

  return { updateCallback };
};
